<template>
  <div></div>
</template>

<script>
import Vue from 'vue';

export default {
  name: 'Logout',
  mounted () {
    this.$http.post('/auth/logout').then(() => {
      window.localStorage.setItem('token', '');
      Vue.prototype.$http.defaults.headers.Authorization = 'Bearer none';
      this.$store.commit('setCustomerID', 0);
      this.$store.commit('setUserID', 0);
      this.$store.commit('setUserName', '');
      this.$store.commit('setUserEmail', '');
      this.$store.commit('setUserPermissions', {});
      this.$store.commit('setUserType', '');
      this.$store.commit('setUserLang', '');
      this.$router.push({ name: 'Logowanie' });
    }).catch((error) => {
      console.log(error);
      window.localStorage.setItem('token', '');
      Vue.prototype.$http.defaults.headers.Authorization = 'Bearer none';
      this.$store.commit('setCustomerID', 0);
      this.$store.commit('setUserID', 0);
      this.$store.commit('setUserName', '');
      this.$store.commit('setUserPermissions', {});
      this.$store.commit('setUserType', '');
      this.$store.commit('setUserLang', '');
      this.$router.push({ name: 'Logowanie' });
    });
  }
}
</script>
